export default __webpack_public_path__ + "static/guarantee-5e88511a3c871a95b83ec4f200e2b434.svg";